/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {HeadFC, Link, PageProps, useStaticQuery, graphql} from "gatsby";
import Layout from "components/Layout/Layout";
import ThemeSlider from 'components/ThemeSlider';
import ThemeSection from "components/Themes/Section/ThemeSection";
import Faq from "components/faq";
import FigmaSection from "components/homepage/figmasection";
import ShopifySection from "components/homepage/shopifySection";
import BundleSection from "components/homepage/bundleSection";
import CotsSection from "components/homepage/CotsSection";
import SiteMetaData from "components/SEO/SiteMetaData/SiteMetaData";
export const pageMetaData = {
  title: 'Home | Polo Themes',
  description: 'Polothemes sells e-commerce themes (figma, tailwindcss, nextjs), currently nextjs themes only support shopify',
  keywords: 'polothemes,responsive design, gumroad',
  slug: '/'
};
export const IndexPage = ({data}) => {
  const _components = Object.assign({
    main: "main",
    div: "div",
    h2: "h2",
    button: "button"
  }, _provideComponents());
  const heroSectionThemes = data.mdx.frontmatter.heroSectionThemes.map(theme => ({
    ...theme,
    featuredImage: {
      src: theme.image.src.childrenImageSharp[0].fluid.src,
      alt: theme.image.alt
    }
  }));
  const themeSections = data.mdx.frontmatter.themeSections;
  const faqAccordionData = data.mdx.frontmatter.faqAccordionData;
  return React.createElement(Layout, null, React.createElement(_components.main, null, React.createElement(_components.div, null, React.createElement(_components.div, {
    className: "container mx-auto"
  }, React.createElement(ThemeSlider, {
    themes: heroSectionThemes
  })), React.createElement(FigmaSection), React.createElement(ShopifySection), React.createElement(BundleSection), React.createElement(_components.div, {
    className: "mb-20 container mx-auto"
  }, themeSections.map((item, index) => React.createElement(_components.div, {
    className: "mb-8",
    key: index
  }, React.createElement(_components.div, {
    className: "flex justify-between items-center mb-8"
  }, React.createElement(_components.h2, {
    className: "font-bold text-gray-900 text-3xl"
  }, item.label), React.createElement(Link, {
    to: item.slug
  }, React.createElement(_components.button, {
    className: "btn-primary-outline"
  }, "View all"))), React.createElement(_components.div, {
    className: "grid lg:grid-cols-3 lg:gap-6 gap-8"
  }, React.createElement(ThemeSection, {
    tag: item.tagName,
    limit: 3
  }))))), React.createElement(Faq, {
    faqAccordionData: faqAccordionData
  }))));
};
const MDXLayout = IndexPage;
export const Head = ({data}) => {
  return React.createElement(SiteMetaData, {
    siteMetadata: data.site.siteMetadata,
    pageMetaData: pageMetaData,
    path: pageMetaData.slug
  });
};
export const query = graphql`
  query {
    site {
      siteMetadata {
        title
        siteUrl
        headline
        description
        keywords
      }
    }
    mdx(frontmatter: { type: { eq: "homepage" } }) {
      frontmatter {
        themeSections {
          slug
          label
          tagName
        }
        faqAccordionData {
          title
          content
        }
        heroSectionThemes {
          id
          name
          description
          image {
            src {
            childrenImageSharp {
              fluid {
                src
              }
            }
          }
          alt
          }
          platforms {
            name
            previewUrl
            detailsUrl
          }
        }
      }
    }
  }
`;
function _createMdxContent(props) {
  return React.createElement(React.Fragment);
}
function MDXContent(props = {}) {
  return React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props));
}
export default MDXContent;
